/* eslint-disable sonarjs/cognitive-complexity */
import React, { useEffect, useState } from 'react';
import {
  getDynamicLabelValues,
  getLabelFromCopyOrFromTranslation,
  renderLabel,
} from '@tcp/core/src/utils/labels/labelUtilty.js';
import { getIconPath, isCanada, isMobileWeb } from '../../../../../../../utils';
import BodyCopy from '../../../../../../common/atoms/BodyCopy';
import Image from '../../../../../../common/atoms/Image';
import withStyles from '../../../../../../common/hoc/withStyles';
import styles from '../styles/BossUnavailabelGroup.style';
import BossUnavailabelProductTile from './BossUnavailableProductTile';
import BossUnavailableLabels, { CHECKOUT_LABELS } from './BossUnavailable.Labels';
import Anchor from '../../../../../../common/atoms/Anchor';
import DynamicFreeSippingModal from '../../../../../../common/organisms/ProductPickup/views/DynamicFreeSipping.modal.view';

const BossUnavailabelGroup = (props) => {
  const checkoutLabels = getLabelFromCopyOrFromTranslation(CHECKOUT_LABELS, BossUnavailableLabels);
  const { shipping } = checkoutLabels;
  const {
    className,
    bossUnavailableProducts,
    isCrossBrandMerchandisingEnabled,
    cookieToken,
    currencyExchange,
    getBossUnavailableListAction,
    bossUnavailableListId,
    removeItemsToBossUnavailableItemAction,
    isBossCart,
    resetBossUnavailableStateAction,
    isDynamicFreeShippingEnabled,
    freeShippingThreshold,
    dynamicShippingCharge,
    isBossEnabled,
    isDesktopProductTileCleanUpDisabled,
  } = props;
  const [dfsModalOpen, toggleDFSModal] = useState(false);

  const hideBoss = () => {
    return isCanada() || !isBossEnabled;
  };

  const renderFreeShippingMessage = () => {
    const freeShipsMsg = renderLabel(
      getDynamicLabelValues('dynamic.browse_d.lbl_ships_free_msg'),
      'lbl_ships_free_msg'
    )?.split('##');
    return isDynamicFreeShippingEnabled && freeShippingThreshold > 0 ? (
      <>
        <div className="free-ship-message">
          {freeShipsMsg && freeShipsMsg[0] + freeShippingThreshold + freeShipsMsg[1]}
          <Anchor
            noLink
            handleLinkClick={(e) => {
              e.preventDefault();
              toggleDFSModal(!dfsModalOpen);
            }}
            title={'Details'}
            className="free-ship-anchor"
          >
            {'Details'}
          </Anchor>
        </div>
      </>
    ) : null;
  };
  useEffect(() => {
    if (bossUnavailableProducts?.length === 0 && isBossCart) {
      getBossUnavailableListAction();
    }
  }, []);
  useEffect(() => {
    if (!isBossCart) {
      resetBossUnavailableStateAction();
    }
  }, [isBossCart]);
  if (bossUnavailableProducts?.length > 0 && isBossCart) {
    return (
      <div className={className}>
        <div className="boss-list-container">
          <div className="header-info">
            {isDesktopProductTileCleanUpDisabled && (
              <div className="header-icon">
                <span className="info-notification">!</span>
              </div>
            )}
            <div className="header-content">
              <BodyCopy
                fontSize={isMobileWeb() ? 'fs12' : 'fs16'}
                className={`elem-pl-SM ${!isDesktopProductTileCleanUpDisabled && 'elem-pb-XS'}`}
                fontFamily="secondary"
                fontWeight={isDesktopProductTileCleanUpDisabled ? 'bold' : 'extrabold'}
              >
                {renderLabel(
                  getDynamicLabelValues('dynamic.cart.lbl_boss_unavailable_group_header'),
                  'lbl_boss_unavailable_group_header'
                )}
              </BodyCopy>
              <BodyCopy
                fontSize={isMobileWeb() ? 'fs12' : 'fs16'}
                className="elem-pl-SM  "
                fontFamily="secondary"
                fontWeight="medium"
              >
                {renderLabel(
                  getDynamicLabelValues('dynamic.cart.lbl_boss_unavailable_group_sub_header'),
                  'lbl_boss_unavailable_group_sub_header'
                )}
              </BodyCopy>
            </div>
          </div>
          <div className="container-heading">
            <div className="container-heading-left-section">
              <Image className={'elem-pl-XS elem-pr-XS'} src={getIconPath('shipping-section')} />
              <BodyCopy
                fontSize={isMobileWeb() ? 'fs16' : 'fs18'}
                fontFamily="secondary"
                fontWeight="extrabold"
                className={'text-capitalize'}
              >
                {renderLabel(shipping.lbl_shipping_header, 'lbl_shipping_header')?.toLowerCase()}
              </BodyCopy>
              <BodyCopy
                fontSize={'fs16'}
                className="elem-pl-SM total-items hide-on-mobile"
                fontFamily="secondary"
                fontWeight="semibold"
              >
                {`${bossUnavailableProducts?.length} of ${bossUnavailableProducts?.length} items`}
              </BodyCopy>
            </div>

            <BodyCopy
              fontSize={'fs14'}
              className="elem-pl-SM hide-on-desktop "
              fontFamily="secondary"
              fontWeight="bold"
            >
              {`${bossUnavailableProducts?.length}/${bossUnavailableProducts?.length} items`}
            </BodyCopy>
          </div>
          {renderFreeShippingMessage()}
          {bossUnavailableProducts?.map((data) => {
            return (
              <BossUnavailabelProductTile
                productDetails={data}
                isCrossBrandMerchandisingEnabled={isCrossBrandMerchandisingEnabled}
                cookieToken={cookieToken}
                currencyExchange={currencyExchange}
                bossUnavailableListId={bossUnavailableListId}
                removeItemsToBossUnavailableItemAction={removeItemsToBossUnavailableItemAction}
                isMobileWebProductTile={isMobileWeb()}
                isDesktopProductTileCleanUpDisabled={isDesktopProductTileCleanUpDisabled}
              />
            );
          })}
          <DynamicFreeSippingModal
            openState={dfsModalOpen}
            onRequestClose={() => {
              toggleDFSModal(false);
            }}
            showShipToStoreMsg={!hideBoss()}
            freeShippingThreshold={freeShippingThreshold}
            dynamicShippingCharge={dynamicShippingCharge}
          />
        </div>
      </div>
    );
  }
  return null;
};

export default withStyles(BossUnavailabelGroup, styles);
